import styled from 'styled-components';

export const VoucherContainer = styled.div`
  margin-bottom: 5rem;

  & > img {
    width: 100%;
    box-shadow: 0px 8px 4px rgba(0, 0, 0, 0.13);
  }

  @media (max-width: 500px) {
    margin-bottom: 2rem;
  }
`;

export const VoucherButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5rem;
  width: 100%;

  & > a,
  button {
    display: flex;
    align-items: center;
    background: none;
    border: 0;

    img {
      height: 5.4rem;
      margin-right: 2rem;
    }

    span {
      font-weight: 900;
      font-size: 2.2rem;
      color: #323232;
    }

    @media (max-width: 560px) {
      img {
        height: 4rem;
      }

      span {
        font-size: 2rem;
      }
    }

    @media (max-width: 500px) {
      img {
        height: 4rem;
      }
    }

  }

  & > a:first-child {
    margin-right: 6rem;
  }

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;

    & > :first-child {
      margin-bottom: 1rem;
    }

    & > a:first-child {
      margin-right: 0rem;
    }
  }

  @media (max-width: 420px) {
    & > a,
    button {
      img {
        height: 40px;
        margin-right: 1.5rem;
      }

      span {
        font-size: 2rem;
      }
    }
  }
`;
